var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-wrapper",attrs:{"id":"app"}},[(this.$route.name !== 'login')?_c('Navigation'):_vm._e(),_c('main',{staticClass:"l-main"},[_c('router-view',{key:_vm.$route.fullPath}),_c('Modal')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }